import Vue from 'vue'
import Snotify from 'vue-snotify'

import App from './App'
import plugins from './plugins'
import filters from './filters'
import directives from './directives'
import store from './vuex/store'
import router from './router'
import routerInit from './router-actions'
import AV from 'leancloud-storage'
import '@/lib/http'

routerInit(router)

AV.init({
  appId: APP_ID,
  appKey: APP_KEY
})

plugins(Vue)
filters(Vue)
directives(Vue)

const options = {
  toast: {
    // animation: {
    //   enter: 'bounceInDown',
    //   exit: 'bounceInDown',
    //   time: 400
    // },
    showProgressBar: false,
    timeout: 2000
    // position: SnotifyPosition.rightBottom
  }
}

Vue.use(Snotify, options)

new Vue({
  store,
  router,
  ...App
}).$mount('#app')

// window.router = router
